
import {FrxBaseBean} from './frxbasebean';

export class Nomenclature extends FrxBaseBean {
	name: string;
	copy(source: Nomenclature) {
		super.copy(source);
		this.name = source.name;
	}
}
